import React from "react";
import { PropTypes } from "prop-types";

const NipSelect = ({
  field,
  name,
  options,
  form,
  label,
  placeholder,
  id,
  onChange,
  handleBlur,
}) => {
  return (
    <div className="nip-select-main-group">
      <div className="form-selec-group2">
        <label className="form-selec-p">{label}</label>
        <select
          className="form-selec2"
          name={(field && field.name) || name}
          value={(field && field.value) || ""}
          onChange={(field && field.onChange) || onChange}
          onBlur={handleBlur}
          id={id}
          placeholder={placeholder}
        >
          <option value="" disabled defaultValue className="default">
            {placeholder}
          </option>
          {options &&
            options.map((option, index) => (
              <option key={option.id || index} value={option.value || ""}>
                {option.name || option.value}
              </option>
            ))}
        </select>
      </div>
      {form && form.touched[field.name] && form && form.errors[field.name] && (
        <small className="errors">{form.errors[field.name]}</small>
      )}
    </div>
  );
};

NipSelect.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.any,
    onChange: PropTypes.any,
    value: PropTypes.any,
  }),
  form: PropTypes.shape({
    errors: PropTypes.any,
    touched: PropTypes.any,
  }),
  handleBlur: PropTypes.any,
  id: PropTypes.any,
  label: PropTypes.any,
  name: PropTypes.any,
  onChange: PropTypes.any,
  options: PropTypes.array,
  placeholder: PropTypes.any,
  sublabel: PropTypes.any,
};

export default NipSelect;
